export type IParams = Record<
  string,
  undefined | string | number | boolean | (string | number | boolean)[]
>;

export type ParamsOptions = {
  arrayFormat?: 'brackets' | 'repeat';
};

export const generateSearchParams = (params: IParams, options?: ParamsOptions): URLSearchParams => {
  const searchParams = new URLSearchParams();
  const arrayFormat = options?.arrayFormat ?? 'brackets';

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => {
        const paramKey = arrayFormat === 'repeat' ? key : key + '[]';
        searchParams.append(paramKey, String(v));
      });
    } else if (value !== undefined) {
      searchParams.set(key, String(value));
    }
  });

  return searchParams;
};
